module.exports = __webpack_public_path__ + "img/s-6.c061948d.png";